import {Types} from "../../../type/Types";

export type MappedImage = {
    id: number
    shoppingPathId: number
    orderNumber: bigint
    fileUrl: string
    createdAt: string
    modifiedAt?: string | null
    deletedAt?: string | null
}

export type MappedImageUrls = Record<number, MappedImage | null>

export type ShoppingPresentationValueObject = {
    shoppingPathJointId: bigint
    userId: bigint
    storeName: string | null
    productName: string | null
    productPrice: number | null
    productImageUrl: string | null
    rank: number | null
    mainKeyword: string | null
    format: string | null
    mappedImageUrls: MappedImageUrls
    browser: string | null
    visibility: number | null
    title: string | null
    description: string | null
    catalogRank: number | null
    catalogProductName: string | null
    catalogLowestPrice: number | null
    catalogDiscountedPrice: number | null
    catalogDeliveryFee: number | null
    pathType: number
    reviewCount: number | null
    reviewScore: number | null
    mallCount: number | null
}

export namespace ShoppingPresentationValueObject {
    export function construct(o: any): ShoppingPresentationValueObject {
        return {
            shoppingPathJointId: BigInt(o.shoppingPathJointId),
            userId: BigInt(o.userId),
            storeName: Types.asNull(o.storeName, String),
            productName: Types.asNull(o.productName, String),
            productPrice: Types.asNull(o.productPrice, Number),
            productImageUrl: Types.asNull(o.productImageUrl, String),
            rank: Types.asNull(o.rank, Number),
            mainKeyword: Types.asNull(o.mainKeyword, String),
            format: Types.asNull(o.format, String),
            mappedImageUrls:Types.asNull(o.mappedImageUrls, Object),
            browser: Types.asNull(o.browser, String),
            visibility: Types.asNull(o.visibility, Number),
            title: Types.asNull(o.title, String),
            description: Types.asNull(o.description, String),
            catalogRank: Types.asNull(o.catalogRank, Number),
            catalogProductName: Types.asNull(o.catalogProductName, String),
            catalogLowestPrice: Types.asNull(o.catalogLowestPrice, Number),
            catalogDiscountedPrice: Types.asNull(o.catalogDiscountedPrice, Number),
            catalogDeliveryFee: Types.asNull(o.catalogDeliveryFee, Number),
            pathType: Number(o.pathType),
            reviewCount: Types.asNull(o.reviewCount, Number),
            reviewScore: Types.asNull(o.reviewScore, Number),
            mallCount: Types.asNull(o.mallCount, Number),
        }
    }

    export const description: Record<keyof ShoppingPresentationValueObject, string> = {
        shoppingPathJointId: '쇼핑경로 Joint Id',
        userId: '사용자ID',
        storeName: '스토어명',
        productName: '상품명',
        productPrice: '가격',
        productImageUrl: '상품이미지URL',
        rank: '순위',
        mainKeyword: '메인키워드',
        format: '경로',
        mappedImageUrls: '가이드이미지URLs',
        browser: '브라우저',
        visibility: '보임여부',
        title: '제목',
        description: '설명',
        catalogRank: '카탈로그 순위',
        catalogProductName: '카탈로그 상품명' ,
        catalogLowestPrice: '카탈로그 최저가' ,
        catalogDiscountedPrice: '카탈로그 할인가' ,
        catalogDeliveryFee: '카탈로그 배송비' ,
        pathType: '미션경로',
        reviewCount: '리뷰수',
        reviewScore: '별점',
        mallCount: '판매처수',
    }
}